import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import axios from "axios";
import navBarEn from "../../../../translations/en/navbar.json";
import navBarEs from "../../../../translations/es/navbar.json";
import SpecializedServiceLayout from "../shared/SpecializedServiceLayout";
import specializedArtCareImg from "../../../../assets/imgs/services/international/specialized-care.jpg";
import { getMoreInfoItems } from "../shared/specializedMoreInfoHelpers";

function SpecializedCare() {
  const [t] = useTranslation("specializedCarePage");
  const [tSMetaData] = useTranslation("metaData");
  const idSpecializedCare = "4a986cde-471f-4b26-a932-356472583a96";
  const [textDescription, setTextDescription] = useState("");
  const [accordion1, setAccordion1] = useState("");
  const [accordion2, setAccordion2] = useState("");
  const [accordion3, setAccordion3] = useState("");

  sessionStorage.setItem(
    "routeEs",
    `/${navBarEs["category-services"].services}/${
      Object.keys(navBarEs["products-submenu"])[1]
    }/${Object.keys(navBarEs["especializado-submenu"])[1]}`
  );

  sessionStorage.setItem(
    "routeEn",
    `/${navBarEn["category-services"].services}/${
      Object.keys(navBarEn["products-submenu"])[1]
    }/${Object.keys(navBarEn["specialized-submenu"])[1]}`
  );

  useEffect(() => {
    let currentLng = "";
    localStorage.getItem("lng")
      ? (currentLng = `${localStorage.getItem("lng")}`)
      : (currentLng = "es");

    axios
      .get(
        `${process.env.REACT_APP_URL_BACKEND}/api/textWeb/text/${idSpecializedCare}`)
      .then((response) => {
        if (currentLng === "es") {
          setTextDescription(
            response.data.textWeb.text_es["01-descripción"].content
          );
          setAccordion1(
            response.data.textWeb.text_es["02-Restricciones y Regulaciones"]
              .content
          );
          setAccordion2(
            response.data.textWeb.text_es[
              "03-Documentación, Aceptación y Recolección"
            ].content
          );
          setAccordion3(
            response.data.textWeb.text_es["04-Manejo Especial"].content
          );
        } else {
          setTextDescription(
            response.data.textWeb.text_us["01-description"].content
          );
          setAccordion1(
            response.data.textWeb.text_us["02-Restrictions and Regulations"]
              .content
          );
          setAccordion2(
            response.data.textWeb.text_us["03-Check-in, Acceptance and Pickup"]
              .content
          );
          setAccordion3(
            response.data.textWeb.text_us["04-Special Handling"].content
          );
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  return (
    <SpecializedServiceLayout
      metaTitle={tSMetaData("specializedCare.title")}
      metaDescription={tSMetaData("specializedCare.description")}
      imgBackground={specializedArtCareImg}
      pageTitle={t("header.title")}
      descriptionApiString={textDescription}
      descriptionFallbackJson={t("description.content")}
      quoteBtn={t("header.quote-btn")}
      quoteProductID="btnQuoteSpecializedCare"
      contactSales={t("header.contact-sales")}
      contactProductID="btnContactSpecializedCare"
      prepareChargeTitle={t("header.prepare-charge")}
      accordionConfigs={[
        {
          id: 1,
          title: t("accordion-1.title"),
          apiContent: accordion1,
          fallbackContentJson: t("accordion-1.content"),
        },
        {
          id: 2,
          title: t("accordion-2.title"),
          apiContent: accordion2,
          fallbackContentJson: t("accordion-2.content"),
        },
        {
          id: 3,
          title: t("accordion-3.title"),
          apiContent: accordion3,
          fallbackContentJson: t("accordion-3.content"),
        },
      ]}
      moreInfoLeft={{
        title: t("non-applicable-charges.title"),
        items: getMoreInfoItems(t, "non-applicable-charges"),
      }}
      moreInfoRight={{
        title: t("additional-conditions.title"),
        items: getMoreInfoItems(t, "additional-conditions"),
      }}
    />
  );
}

export default SpecializedCare;
